import axios from "../config/axiosInstance";

export const authService = {
  login: async (credentials) => {
    return await axios.post(`/auths/login?type=${"Client"}`, credentials);
  },

  confirmEmail: async (userId, token) => {
    return await axios.get(
      `/auths/confirm-email?userId=${userId}&token=${token}`
    );
  },

  forgotPassword: async (email) => {
    return await axios.post(`/auths/forgot-password?email=${email}`);
  },

  resetPassword: async (resetPasswordDTO) => {
    return await axios.post(`/auths/reset-password`, resetPasswordDTO);
  },

  loginGoogle: async (loginGoogleDTO) => {
    return await axios.post(
      `/auths/login-google?type=${"Client"}`,
      loginGoogleDTO
    );
  },

  loginFacebook: async (accessToken) => {
    return await axios.post(
      `/auths/login-facebook?accessToken=${accessToken}&type=${"Client"}`
    );
  },
};
